var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { on: { change: _vm.logChangeData } }, [
    _c("div", { staticClass: "setting_content" }, [
      _c("div", { staticClass: "setting_content_main" }, [
        _c("h2", { staticClass: "setting_content_title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.messageLabelsProperties.TAB_HEADER) +
              "\n      "
          )
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.messageLabelsProperties.ENTRY_SCREEN_HEADER) +
                "\n        "
            )
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.messageLabelsProperties.STEP_MESSAGE_INPUT_TITLE) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftMessage.titleEntry,
                    expression: "draftMessage.titleEntry"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder:
                    _vm.messageLabelsProperties.ENTRY_MESSAGE_PLACEHOLDER
                },
                domProps: { value: _vm.draftMessage.titleEntry },
                on: {
                  change: function($event) {
                    return _vm.validateTitleEntry()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.draftMessage,
                      "titleEntry",
                      $event.target.value
                    )
                  }
                }
              }),
              _c("p", { staticClass: "setting_unit_annotation" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.messageNotesProperties.ENTRY_TITLE_NOTE) +
                    "\n            "
                )
              ]),
              _c(
                "h6",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthErrorTitleEntry,
                      expression: "lengthErrorTitleEntry"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.messageSettingsProperties.TITLE
                          .ENTRY_TITLE_MAX_LENGTH
                      ) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.messageLabelsProperties.CONFIRM_SCREEN_HEADER) +
                "\n        "
            )
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.messageLabelsProperties.STEP_MESSAGE_INPUT_TITLE) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftMessage.titleConfirm,
                    expression: "draftMessage.titleConfirm"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder:
                    _vm.messageLabelsProperties.CONFIRM_MESSAGE_PLACEHOLDER
                },
                domProps: { value: _vm.draftMessage.titleConfirm },
                on: {
                  change: function($event) {
                    return _vm.validateTitleConfirm()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.draftMessage,
                      "titleConfirm",
                      $event.target.value
                    )
                  }
                }
              }),
              _c("p", { staticClass: "setting_unit_annotation" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.messageNotesProperties.CONFIRM_TITLE_NOTE) +
                    "\n            "
                )
              ]),
              _c(
                "h6",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthErrorTitleConfirm,
                      expression: "lengthErrorTitleConfirm"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.messageSettingsProperties.TITLE
                          .CONFIRM_TITLE_MAX_LENGTH
                      ) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.messageLabelsProperties.CONFIRM_MESSAGE_BODY_INPUT_TITLE
                  ) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftMessage.messageConfirm,
                    expression: "draftMessage.messageConfirm"
                  }
                ],
                staticClass: "setting_form_textarea",
                attrs: {
                  placeholder:
                    _vm.messageLabelsProperties.CONFIRM_MESSAGE_PLACEHOLDER
                },
                domProps: { value: _vm.draftMessage.messageConfirm },
                on: {
                  change: function($event) {
                    return _vm.validateMessageConfirm()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.draftMessage,
                      "messageConfirm",
                      $event.target.value
                    )
                  }
                }
              }),
              _c(
                "h6",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthMessageConfirm,
                      expression: "lengthMessageConfirm"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.messageSettingsProperties.MESSAGE
                          .CONFIRM_BODY_MAX_LENGTH
                      ) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.messageLabelsProperties.COMPLETE_SCREEN_HEADER) +
                "\n        "
            )
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.messageLabelsProperties.STEP_MESSAGE_INPUT_TITLE) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftMessage.titleCompletion,
                    expression: "draftMessage.titleCompletion"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder:
                    _vm.messageLabelsProperties
                      .COMPLETE_STEP_MESSAGE_PLACEHOLDER
                },
                domProps: { value: _vm.draftMessage.titleCompletion },
                on: {
                  change: function($event) {
                    return _vm.validateTitleCompletion()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.draftMessage,
                      "titleCompletion",
                      $event.target.value
                    )
                  }
                }
              }),
              _c("p", { staticClass: "setting_unit_annotation" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.messageNotesProperties.COMPLETE_TITLE_NOTE) +
                    "\n            "
                )
              ]),
              _c(
                "h6",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthErrorTitleCompletion,
                      expression: "lengthErrorTitleCompletion"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.messageSettingsProperties.TITLE
                          .COMPLETE_TITLE_MAX_LENGTH
                      ) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.messageLabelsProperties
                      .COMPLETE_MESSAGE_SUBJECT_INPUT_TITLE
                  ) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftMessage.messageTitleCompletion,
                    expression: "draftMessage.messageTitleCompletion"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder:
                    _vm.messageLabelsProperties.COMPLETE_MESSAGE_PLACEHOLDER
                },
                domProps: { value: _vm.draftMessage.messageTitleCompletion },
                on: {
                  change: function($event) {
                    return _vm.validateMessageTitleCompletion()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.draftMessage,
                      "messageTitleCompletion",
                      $event.target.value
                    )
                  }
                }
              }),
              _c(
                "h6",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthMessageTitleCompletion,
                      expression: "lengthMessageTitleCompletion"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.messageSettingsProperties.MESSAGE
                          .COMPLETE_TITLE_MAX_LENGTH
                      ) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.messageLabelsProperties
                      .COMPLETE_MESSAGE_BODY_INPUT_TITLE
                  ) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftMessage.messageBodyCompletion,
                    expression: "draftMessage.messageBodyCompletion"
                  }
                ],
                staticClass: "setting_form_textarea",
                attrs: {
                  placeholder:
                    _vm.messageLabelsProperties.COMPLETE_MESSAGE_PLACEHOLDER
                },
                domProps: { value: _vm.draftMessage.messageBodyCompletion },
                on: {
                  change: function($event) {
                    return _vm.validateMessageBodyCompletion()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.draftMessage,
                      "messageBodyCompletion",
                      $event.target.value
                    )
                  }
                }
              }),
              _c(
                "h6",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthErrorMessageBodyCompletion,
                      expression: "lengthErrorMessageBodyCompletion"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.messageSettingsProperties.MESSAGE
                          .COMPLETE_BODY_MAX_LENGTH
                      ) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }